module.exports = __webpack_public_path__ + "static/media/minus-cirlce.ec7d9481.svg";